import { gql } from "graphql-tag";
import { SHIPPING_ADDRESS_REPORT_ROW } from "./Fragments";

export const GET_SHIPPING_ADDRESS_REPORT = gql`
  query GetShippingAddressReport(
    $page: Int
    $limit: Int
    $showDeleted: Boolean
    $report_mode: String!
    $col: String
    $type: String
  ) {
    shipping_address_report(
      limit: $limit
      page: $page
      showDeleted: $showDeleted
      report_mode: $report_mode
      col: $col
      type: $type
    ) {
      total
      per_page
      current_page
      from
      to
      last_page
      has_more_pages
      data {
        ...ShippingAddressReportRow
      }
    }
  }
  ${SHIPPING_ADDRESS_REPORT_ROW}
`;

export const SEARCH_SHIPPING_ADDRESS_REPORT = gql`
  query SearchShippingAddressReport(
    $page: Int
    $limit: Int
    $filter: String
    $search_key: String
    $locale: String
    $types: String
    $showDeleted: Boolean
    $col: String
    $type: String
    $date_to: String
    $date_from: String
    $report_mode: String!
  ) {
    search_shipping_address_report(
      limit: $limit
      page: $page
      filter: $filter
      search_key: $search_key
      locale: $locale
      types: $types
      showDeleted: $showDeleted
      col: $col
      type: $type
      date_to: $date_to
      date_from: $date_from
      report_mode: $report_mode
    ) {
      total
      per_page
      current_page
      from
      to
      last_page
      has_more_pages
      data {
        ...ShippingAddressReportRow
      }
    }
  }
  ${SHIPPING_ADDRESS_REPORT_ROW}
`;

export const GET_SHIPPING_ADDRESS_GROUP_DETAIL = gql`
  query GetShippingAddressGroupDetail(
    $customer_uuid: String!
    $address_group_key: String!
    $showDeleted: Boolean
    $page: Int
    $limit: Int
  ) {
    shipping_address_group_detail(
      customer_uuid: $customer_uuid
      address_group_key: $address_group_key
      showDeleted: $showDeleted
      page: $page
      limit: $limit
    ) {
      shipping_address {
        name
        company
        address_1
        address_2
        city
        postal_code
        country {
          name
        }
      }
      orders {
        total
        per_page
        current_page
        from
        to
        last_page
        has_more_pages
        data {
          order {
            id
            uuid
            name
            created_at
            path
          }
          order_grand_total
          order_lines {
            product_name
            quantity
            line_total
          }
        }
      }
    }
  }
`;

export default {
  GET_SHIPPING_ADDRESS_REPORT,
  SEARCH_SHIPPING_ADDRESS_REPORT,
  GET_SHIPPING_ADDRESS_GROUP_DETAIL
};
